/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-10-12 16:04:14
 */
import env from "../configs/env";
import { defHttp } from "../utils/http/axios";

const api = {
  avatarList: "/sys/user/avatar/predefined",
  getAvatar: "/sys/user/avatar/data",
  setAvatar: "/sys/user/avatar/set",
  uploadAvatar: "/sys/user/avatar/set/upload",
  resetPassword:"/sys/user/password/reset",
};

export function getAvatarList() {
  return defHttp.get({ url: api.avatarList }, {});
}

export function genarateAvatarUrl(avatarPath) {
  return env.apiBaseUri + api.getAvatar + `?name=${encodeURIComponent(avatarPath)}`;
}

export function setAvatar(avatar) {
  return defHttp.post({ url: api.setAvatar, data: { avatar } }, {});
}

export function uploadAvatar(formData) {
  return defHttp.uploadFile({ url: api.uploadAvatar }, formData, {
    onUploadProgress(ev) {
      console.log(">>> upload progress",ev);
    },
  });
}
export function resetUserPassword(params) {
  return defHttp.get({ url: api.resetPassword, params });
}
